import { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useAddUserPaymentMethodMutation = createMutationHook(
  PaymentApiClient.addUserPaymentMethod,
  {
    mutationKey: ['addUserPaymentMethod'],
  },
)
